<template>
  <div
    :class="['UILoader', `UILoader--theme-${theme}`]"
    data-testid="ui-loader"
  />
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

defineProps({
  theme: {
    type: String as PropType<'dark' | 'light'>,
    default: 'dark',
  },
})
</script>

<style scoped lang="scss">
.UILoader {
  --size: 2rem;
  --color: #{$color-primary-50};

  border: 3px solid var(--color);
  border-right-color: transparent;
  border-radius: 50%;
  width: var(--size);
  height: var(--size);
  animation: 0.75s linear infinite spinner-border;

  @keyframes spinner-border {
    to {
      transform: rotate(360deg);
    }
  }

  &.UILoader--theme-dark {
    --color: #{$color-primary-50};
  }
  &.UILoader--theme-light {
    --color: #{$color-neutral-20};
  }
}
</style>
